import BustePagaOperaio from "@/components/BustePagaOperaio";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Archive, FileText, FileUp, GitMerge, Pencil, Plus, RotateCcw, Trash2, Upload } from "lucide-react";
import { toast } from "sonner";
import { api, API, eur, formatApiError } from "@/lib/api";
import AppShell from "@/components/AppShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { openAttachmentViewer } from "@/lib/attachmentViewer";

const categorieDocumenti = [
  "Documento personale",
  "UNILAV",
  "Busta paga",
  "Contratto di lavoro",
  "Documento d'identità",
  "Codice fiscale",
  "Visita medica",
  "Attestato sicurezza",
  "Patentino",
  "Altro documento",
];
const statoScadenzaDocumento = (scadenza) => {
  if (!scadenza) {
    return {
      colore: "bg-slate-300",
      testo: "Nessuna scadenza",
    };
  }

  const oggi = new Date();
  oggi.setHours(0, 0, 0, 0);

  const data = new Date(`${scadenza}T00:00:00`);
  data.setHours(0, 0, 0, 0);

  const giorni = Math.ceil(
    (data.getTime() - oggi.getTime()) /
      (1000 * 60 * 60 * 24)
  );

  if (giorni < 0) {
    return {
      colore: "bg-red-500",
      testo: "Documento scaduto",
    };
  }

  if (giorni <= 30) {
    return {
      colore: "bg-orange-500",
      testo:
        giorni === 0
          ? "Scade oggi"
          : `Scade tra ${giorni} giorni`,
    };
  }

  return {
    colore: "bg-green-500",
    testo: `Scade tra ${giorni} giorni`,
  };
};

const vuoto = () => ({ nome:"", cognome:"", codice_fiscale:"", data_nascita:"", luogo_nascita:"", indirizzo:"", telefono:"", email:"", azienda_id:null, azienda_nome:"", ruolo:"", costo_orario:"", data_assunzione:"", note:"" });

export default function OperaiPage(){
  const navigate=useNavigate(); const [items,setItems]=useState([]); const [aziende,setAziende]=useState([]); const [archivio,setArchivio]=useState(false); const [open,setOpen]=useState(false); const [detail,setDetail]=useState(null); const [editing,setEditing]=useState(null); const [form,setForm]=useState(vuoto()); const [docFile,setDocFile]=useState(null); const [docTipo,setDocTipo]=useState("Documento personale"); const [docScadenza,setDocScadenza]=useState("");
  const [importOpen,setImportOpen]=useState(false); const [cedoliniFile,setCedoliniFile]=useState(null); const [anteprima,setAnteprima]=useState(null); const [analisi,setAnalisi]=useState(false); const [importazione,setImportazione]=useState(false);
  const [riprendiImportazione,setRiprendiImportazione]=useState(false);
  const [saving,setSaving]=useState(false); const [duplicatiOpen,setDuplicatiOpen]=useState(false); const [duplicati,setDuplicati]=useState([]); const [duplicatiLoading,setDuplicatiLoading]=useState(false);
  const load=()=>api.get("/gestionale/operai",{params:{include_archived:archivio}}).then(r=>{const elenco=Array.isArray(r.data)?r.data:[];setItems(archivio?elenco.filter(x=>x.archived_at):elenco.filter(x=>!x.archived_at));});
  useEffect(()=>{load();api.get("/gestionale/anagrafiche/aziende").then(r=>setAziende(r.data||[]));},[archivio]);

  useEffect(() => {
    const parametri = new URLSearchParams(
      window.location.search
    );

    const aperturaDaDashboard =
      parametri.get("operaio");

    if (!aperturaDaDashboard) return;

    api
      .get(`/gestionale/operai/${aperturaDaDashboard}`)
      .then((response) => {
        setDetail(response.data);
      })
      .catch(() => {
        toast.error("Scheda operaio non trovata");
      });
  }, []);
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));
  const nuovo=()=>{setEditing(null);setForm(vuoto());setOpen(true)};
  const modifica=x=>{setEditing(x);setForm({...vuoto(),...x,costo_orario:String(x.costo_orario??"")});setOpen(true)};
  const salva=async e=>{e.preventDefault();if(saving)return;setSaving(true);try{const payload={...form,costo_orario:Number(String(form.costo_orario).replace(",","."))||0};editing?await api.put(`/gestionale/operai/${editing.id}`,payload):await api.post("/gestionale/operai",payload);toast.success("Operaio salvato");setOpen(false);load();if(riprendiImportazione){setRiprendiImportazione(false);setAnteprima(null);setImportOpen(true);setTimeout(()=>analizzaCedolini(),100);}}catch(err){toast.error(formatApiError(err.response?.data?.detail));}finally{setSaving(false)}};
  const controllaDuplicati=async()=>{setDuplicatiLoading(true);setDuplicatiOpen(true);try{const r=await api.get("/gestionale/operai/duplicati/controllo");setDuplicati(r.data?.gruppi||[]);}catch(err){toast.error(formatApiError(err.response?.data?.detail||"Controllo non riuscito"));}finally{setDuplicatiLoading(false)}};
  const unisciDuplicati=async gruppo=>{const principale=gruppo.operai.find(x=>x.id===gruppo.principale_id);if(!window.confirm(`Unire le schede duplicate in ${principale?.cognome||""} ${principale?.nome||""}? Tutto lo storico sarà conservato.`))return;try{await api.post("/gestionale/operai/duplicati/consolida",{principale_id:gruppo.principale_id,duplicato_ids:gruppo.operai.filter(x=>x.id!==gruppo.principale_id).map(x=>x.id)});toast.success("Schede unite senza perdere lo storico");await controllaDuplicati();load();}catch(err){toast.error(formatApiError(err.response?.data?.detail));}};
  const archivia=async x=>{if(!window.confirm(`Archiviare ${x.nome} ${x.cognome}? Lo storico dei cantieri resterà invariato.`))return;await api.delete(`/gestionale/operai/${x.id}`);setOpen(false);setEditing(null);load();};
  const ripristina=async x=>{await api.post(`/gestionale/operai/${x.id}/restore`);load();};
  const eliminaDefinitivamente=async x=>{if(!window.confirm(`Eliminare DEFINITIVAMENTE ${x.cognome} ${x.nome}? Questa operazione non può essere annullata.`))return;try{await api.delete(`/gestionale/operai/${x.id}/definitivo`);toast.success("Operaio eliminato definitivamente");load();}catch(err){toast.error(formatApiError(err.response?.data?.detail||"Eliminazione non riuscita"));}};
  const apri=async x=>{const r=await api.get(`/gestionale/operai/${x.id}`);setDetail(r.data)};
  const uploadDoc = async () => {
    if (!docFile || !detail) return;

    try {
      const fd = new FormData();
      fd.append("file", docFile);

      await api.post(
        `/gestionale/operai/${detail.id}/documenti`,
        fd,
        {
          params: {
            tipo: docTipo,
            scadenza: docScadenza,
          },
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Documento caricato");
      setDocFile(null);
      setDocScadenza("");

      const inputFile = document.getElementById("file-documento-operaio");
      if (inputFile) inputFile.value = "";

      apri(detail);
    } catch (err) {
      toast.error(
        formatApiError(
          err.response?.data?.detail || "Caricamento non riuscito"
        )
      );
    }
  };

  const eliminaDocumento = async (documento) => {
    if (!detail) return;

    if (
      !window.confirm(
        `Eliminare il documento "${documento.nome}"?`
      )
    ) {
      return;
    }

    try {
      await api.delete(
        `/gestionale/operai/${detail.id}/documenti/${documento.id}`
      );

      toast.success("Documento eliminato");
      apri(detail);
    } catch (err) {
      toast.error(
        formatApiError(
          err.response?.data?.detail || "Eliminazione non riuscita"
        )
      );
    }
  };
  const analizzaCedolini=async()=>{if(!cedoliniFile)return;setAnalisi(true);try{const fd=new FormData();fd.append("file",cedoliniFile);const r=await api.post("/gestionale/operai/importa-cedolini/anteprima",fd,{headers:{"Content-Type":"multipart/form-data"}});setAnteprima(r.data);}catch(err){toast.error(formatApiError(err.response?.data?.detail||"Analisi PDF non riuscita"));}finally{setAnalisi(false)}};
  const importaCedolini=async()=>{if(!cedoliniFile||!anteprima?.pronti)return;setImportazione(true);try{const fd=new FormData();fd.append("file",cedoliniFile);const r=await api.post("/gestionale/operai/importa-cedolini/conferma",fd,{headers:{"Content-Type":"multipart/form-data"}});toast.success(`${r.data.importati} documenti importati${r.data.saltati?`, ${r.data.saltati} non importati`:""}`);setImportOpen(false);setCedoliniFile(null);setAnteprima(null);}catch(err){toast.error(formatApiError(err.response?.data?.detail||"Importazione non riuscita"));}finally{setImportazione(false)}};
  const censisciDaCedolino=(riga)=>{const proposta=riga.operaio_proposto||{};const azienda=aziende.find(a=>(a.nome||"").trim().toLocaleLowerCase()===(proposta.azienda_nome||"").trim().toLocaleLowerCase());setEditing(null);setForm({...vuoto(),...proposta,azienda_id:azienda?.id||null,azienda_nome:azienda?.nome||proposta.azienda_nome||""});setRiprendiImportazione(true);setImportOpen(false);setOpen(true)};
  return <AppShell><button onClick={()=>navigate("/gestionale")} className="inline-flex items-center gap-2 text-sm font-semibold text-muted-foreground hover:text-primary mb-6"><ArrowLeft className="h-4 w-4"/>Gestionale</button>
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6"><div><p className="text-xs tracking-[.2em] uppercase font-bold text-muted-foreground">Gestionale</p><h1 className="font-heading text-4xl font-bold mt-2">{archivio?"Archivio operai":"Operai"}</h1></div><div className="flex flex-wrap gap-2"><Button variant="outline" onClick={controllaDuplicati}><GitMerge className="h-4 w-4 mr-2"/>Controlla duplicati</Button><Button variant="outline" onClick={()=>setArchivio(v=>!v)}><Archive className="h-4 w-4 mr-2"/>{archivio?"Operai attivi":"Archivio"}</Button>{!archivio&&<><Button variant="outline" onClick={()=>setImportOpen(true)}><FileUp className="h-4 w-4 mr-2"/>Importa buste paga PDF</Button><Button onClick={nuovo}><Plus className="h-4 w-4 mr-2"/>Nuovo operaio</Button></>}</div></div>
    <div className="rounded-xl border bg-card overflow-auto"><table className="w-full min-w-[950px] text-sm"><thead className="bg-muted"><tr>{["OPERAIO","CODICE FISCALE","AZIENDA","RUOLO","COSTO ORARIO","TELEFONO",""] .map(h=><th key={h} className="p-3 text-left text-xs text-muted-foreground">{h}</th>)}</tr></thead><tbody>{items.length===0?<tr><td colSpan="7" className="p-8 text-center text-muted-foreground">{archivio?"Nessun operaio archiviato":"Nessun operaio"}</td></tr>:items.map(x=><tr key={x.id} className="border-t"><td className="p-3 font-semibold"><button className="hover:text-primary" onClick={()=>navigate(`/gestionale/operai/${x.id}`)}>{x.cognome} {x.nome}</button></td><td className="p-3">{x.codice_fiscale||"-"}</td><td className="p-3">{x.azienda_nome||"-"}</td><td className="p-3">{x.ruolo||"-"}</td><td className="p-3">{eur(x.costo_orario)}/h</td><td className="p-3">{x.telefono||"-"}</td><td className="p-3 whitespace-nowrap">{x.archived_at?<><Button variant="ghost" size="icon" title="Ripristina operaio" onClick={()=>ripristina(x)}><RotateCcw className="h-4 w-4"/></Button><Button variant="ghost" size="icon" title="Elimina definitivamente" className="text-red-600 hover:text-red-700 hover:bg-red-50" onClick={()=>eliminaDefinitivamente(x)}><Trash2 className="h-4 w-4"/></Button></>:<><Button variant="ghost" size="icon" onClick={()=>modifica(x)}><Pencil className="h-4 w-4"/></Button><Button variant="ghost" size="icon" onClick={()=>archivia(x)}><Trash2 className="h-4 w-4"/></Button></>}</td></tr>)}</tbody></table></div>
    <Dialog open={open} onOpenChange={setOpen}><DialogContent className="sm:max-w-3xl max-h-[92vh] overflow-y-auto"><DialogHeader><DialogTitle>{editing?"Modifica operaio":"Nuovo operaio"}</DialogTitle></DialogHeader><form onSubmit={salva} className="space-y-4"><div className="grid grid-cols-1 sm:grid-cols-2 gap-4">{[["Nome *","nome"],["Cognome *","cognome"],["Codice fiscale","codice_fiscale"],["Data di nascita","data_nascita","date"],["Luogo di nascita","luogo_nascita"],["Telefono","telefono"],["Email","email","email"],["Data assunzione","data_assunzione","date"],["Ruolo","ruolo"],["Costo orario","costo_orario","number"]].map(([l,k,t])=><div key={k}><Label>{l}</Label><Input type={t||"text"} step={t==="number"?"0.01":undefined} value={form[k]||""} onChange={e=>set(k,e.target.value)} required={l.includes("*")}/></div>)}<div><Label>Azienda</Label><Select value={form.azienda_id||"__none__"} onValueChange={v=>{const a=aziende.find(x=>x.id===v);setForm(f=>({...f,azienda_id:v==="__none__"?null:v,azienda_nome:a?.nome||""}))}}><SelectTrigger><SelectValue/></SelectTrigger><SelectContent><SelectItem value="__none__">Nessuna</SelectItem>{aziende.map(a=><SelectItem key={a.id} value={a.id}>{a.nome}</SelectItem>)}</SelectContent></Select></div><div><Label>Indirizzo</Label><Input value={form.indirizzo} onChange={e=>set("indirizzo",e.target.value)}/></div></div><div><Label>Note</Label><Textarea value={form.note} onChange={e=>set("note",e.target.value)}/></div><DialogFooter>{editing&&<Button type="button" variant="destructive" onClick={()=>archivia(editing)}><Archive className="h-4 w-4 mr-2"/>Archivia operaio</Button>}<Button type="button" variant="outline" onClick={()=>setOpen(false)}>Annulla</Button><Button type="submit" disabled={saving}>{saving?"Salvataggio...":"Salva"}</Button></DialogFooter></form></DialogContent></Dialog>
    <Dialog open={duplicatiOpen} onOpenChange={setDuplicatiOpen}><DialogContent className="sm:max-w-4xl max-h-[90vh] overflow-y-auto"><DialogHeader><DialogTitle>Controllo duplicati operai</DialogTitle><DialogDescription>Il controllo usa il codice fiscale. Solo quando manca, usa insieme nome, cognome e data di nascita. Gli omonimi con dati differenti restano separati.</DialogDescription></DialogHeader>{duplicatiLoading?<p className="py-8 text-center text-muted-foreground">Controllo in corso...</p>:duplicati.length===0?<p className="py-8 text-center text-green-700 font-semibold">Nessuna scheda duplicata trovata</p>:<div className="space-y-4">{duplicati.map(gruppo=><div key={gruppo.principale_id} className="rounded-xl border p-4"><p className="font-bold mb-3">{gruppo.criterio==="cf"?"Stesso codice fiscale":"Stessa anagrafica completa"}</p><div className="space-y-2">{gruppo.operai.map(x=><label key={x.id} className="flex items-center gap-3 rounded-lg bg-muted/50 p-3"><input type="radio" name={`principale-${gruppo.principale_id}`} checked={gruppo.principale_id===x.id} onChange={()=>setDuplicati(gs=>gs.map(g=>g===gruppo?{...g,principale_id:x.id}:g))}/><span className="flex-1"><b>{x.cognome} {x.nome}</b><span className="block text-xs text-muted-foreground">CF: {x.codice_fiscale||"mancante"} · nascita: {x.data_nascita||"mancante"} · elementi collegati: {x.riferimenti||0}</span></span>{gruppo.principale_id===x.id&&<span className="text-xs font-semibold text-primary">Scheda principale</span>}</label>)}</div><Button className="mt-3" onClick={()=>unisciDuplicati(gruppo)}><GitMerge className="h-4 w-4 mr-2"/>Unisci in sicurezza</Button></div>)}</div>}<DialogFooter><Button variant="outline" onClick={()=>setDuplicatiOpen(false)}>Chiudi</Button></DialogFooter></DialogContent></Dialog>
    <Dialog open={importOpen} onOpenChange={v=>{setImportOpen(v);if(!v){setCedoliniFile(null);setAnteprima(null)}}}>
      <DialogContent className="sm:max-w-6xl max-h-[92vh] overflow-y-auto">
        <DialogHeader><DialogTitle>Importa buste paga da PDF</DialogTitle><DialogDescription>Il collegamento avviene soltanto con codice fiscale esatto e data di nascita coincidente. Il nome non viene usato per associare l'operaio. TFR, tredicesima e quattordicesima restano voci separate nelle Buste paga.</DialogDescription></DialogHeader>
        <div className="flex flex-col sm:flex-row gap-3 items-end"><div className="flex-1"><Label>PDF cedolini *</Label><Input type="file" accept="application/pdf,.pdf" onChange={e=>{setCedoliniFile(e.target.files?.[0]||null);setAnteprima(null)}}/></div><Button type="button" variant="outline" disabled={!cedoliniFile||analisi} onClick={analizzaCedolini}>{analisi?"Analisi...":"Analizza PDF"}</Button></div>
        {anteprima&&<div className="rounded-xl border overflow-auto"><table className="w-full min-w-[1050px] text-sm"><thead className="bg-muted"><tr>{["PAGINA","NOMINATIVO PDF","CODICE FISCALE","DATA NASCITA","PERIODO","TIPO","NETTO","ESITO"].map(h=><th key={h} className="p-3 text-left text-xs text-muted-foreground">{h}</th>)}</tr></thead><tbody>{anteprima.righe.map(r=><tr key={r.pagina} className="border-t"><td className="p-3">{r.pagina}</td><td className="p-3"><div className="font-semibold">{r.nominativo_pdf||"-"}</div>{r.operaio_nome&&<div className="text-xs text-muted-foreground">Associato a: {r.operaio_nome}</div>}</td><td className="p-3 font-mono">{r.codice_fiscale||"-"}</td><td className="p-3">{r.data_nascita||"-"}</td><td className="p-3">{r.mese||"-"}</td><td className="p-3 capitalize">{r.tipo}</td><td className="p-3 font-semibold">{eur(r.importo)}</td><td className="p-3"><span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${r.stato==="pronto"?"bg-green-100 text-green-700":"bg-red-100 text-red-700"}`}>{r.messaggio}</span>{r.stato==="operaio_non_trovato"&&<Button type="button" size="sm" className="mt-2 w-full" onClick={()=>censisciDaCedolino(r)}>Censisci operaio</Button>}</td></tr>)}</tbody></table></div>}
        {anteprima&&<p className="text-sm text-muted-foreground">Pronti: <b>{anteprima.pronti}</b> su {anteprima.righe.length}. Le righe non riconosciute o non coincidenti non verranno importate.</p>}
        <DialogFooter><Button type="button" variant="outline" onClick={()=>setImportOpen(false)}>Annulla</Button><Button type="button" disabled={!anteprima?.pronti||importazione} onClick={importaCedolini}>{importazione?"Importazione...":"Conferma importazione"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
    <Dialog
      open={!!detail}
      onOpenChange={(value) => {
        if (!value) {
          setDetail(null);
          setDocFile(null);
          setDocScadenza("");
        }
      }}
    >
      <DialogContent className="sm:max-w-4xl max-h-[92vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {detail?.cognome} {detail?.nome}
          </DialogTitle>
        </DialogHeader>

        {detail && (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
              <p>
                <b>Azienda:</b> {detail.azienda_nome || "-"}
              </p>

              <p>
                <b>Ruolo:</b> {detail.ruolo || "-"}
              </p>

              <p>
                <b>Codice fiscale:</b>{" "}
                {detail.codice_fiscale || "-"}
              </p>

              <p>
                <b>Costo:</b> {eur(detail.costo_orario)}/h
              </p>
            </div>

            <div className="mb-4"><BustePagaOperaio operaio={detail} /></div>
<div className="border-t pt-4">
              <h3 className="font-bold mb-1 flex items-center gap-2">
                <FileText className="h-4 w-4" />
                Archivio documenti operaio
              </h3>

              <p className="text-sm text-muted-foreground mb-4">
                Carica documenti personali, UNILAV, buste paga,
                contratti, attestati e altri documenti del lavoratore.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
                <div>
                  <Label>Tipo documento *</Label>

                  <Select
                    value={docTipo}
                    onValueChange={setDocTipo}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Seleziona categoria" />
                    </SelectTrigger>

                    <SelectContent>
                      {categorieDocumenti.map((categoria) => (
                        <SelectItem
                          key={categoria}
                          value={categoria}
                        >
                          {categoria}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>

                <div>
                  <Label>Data o scadenza</Label>

                  <Input
                    type="date"
                    value={docScadenza}
                    onChange={(event) =>
                      setDocScadenza(event.target.value)
                    }
                  />
                </div>

                <div>
                  <Label>File *</Label>

                  <Input
                    id="file-documento-operaio"
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx,.xls,.xlsx"
                    onChange={(event) =>
                      setDocFile(event.target.files?.[0] || null)
                    }
                  />
                </div>
              </div>

              <Button
                disabled={!docFile}
                onClick={uploadDoc}
              >
                <Upload className="h-4 w-4 mr-2" />
                Carica documento
              </Button>

              <div className="mt-5 rounded-xl border overflow-hidden">
                {(detail.documenti || []).filter(
                  (documento) => !documento.archived_at
                ).length === 0 ? (
                  <div className="p-8 text-center text-muted-foreground">
                    Nessun documento caricato
                  </div>
                ) : (
                  <div className="divide-y">
                    {(detail.documenti || [])
                      .filter(
                        (documento) => !documento.archived_at
                      )
                      .map((documento) => (
                        <div
                          key={documento.id}
                          className="p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3"
                        >
                          <div className="min-w-0">
                            <div className="flex flex-wrap items-center gap-2">
                                                            <span
                                title={
                                  statoScadenzaDocumento(
                                    documento.scadenza
                                  ).testo
                                }
                                className={`h-3 w-3 rounded-full shrink-0 ${
                                  statoScadenzaDocumento(
                                    documento.scadenza
                                  ).colore
                                }`}
                              />

                              <span className="rounded-full bg-primary/10 px-2.5 py-1 text-xs font-semibold text-primary">
                                {documento.tipo ||
                                  "Documento personale"}
                              </span>

                              <button
                                type="button"
                                className="font-semibold hover:text-primary break-all"
                                onClick={() => openAttachmentViewer(`${API}/gestionale/operai/${detail.id}/documenti/${documento.id}/file`, documento.nome)}
                              >
                                {documento.nome}
                              </button>
                            </div>

                            <p className="mt-2 text-sm text-muted-foreground">
                              {documento.scadenza
                                ? `Data/scadenza: ${documento.scadenza
                                    .split("-")
                                    .reverse()
                                    .join("/")}`
                                : "Nessuna scadenza indicata"}
                            </p>
                          </div>

                          <Button
                            type="button"
                            variant="ghost"
                            size="icon"
                            className="shrink-0 text-destructive hover:bg-destructive/10 hover:text-destructive"
                            title="Elimina documento"
                            onClick={() =>
                              eliminaDocumento(documento)
                            }
                          >
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  </AppShell>;
}
